var _path, _g, _g2, _g3, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimezone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 195,
    viewBox: "0 0 209 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15953_148823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 28,
    width: 145,
    height: 144
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.897 171.978C144.65 171.978 176.876 139.921 176.876 100.376C176.876 60.8309 144.65 28.7734 104.897 28.7734C65.1442 28.7734 32.918 60.8309 32.918 100.376C32.918 139.921 65.1442 171.978 104.897 171.978Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15953_148823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.897 171.978C144.65 171.978 176.876 139.921 176.876 100.376C176.876 60.8309 144.65 28.7734 104.897 28.7734C65.1442 28.7734 32.918 60.8309 32.918 100.376C32.918 139.921 65.1442 171.978 104.897 171.978Z",
    fill: "url(#paint0_linear_15953_148823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.897 171.978C144.65 171.978 176.876 139.921 176.876 100.376C176.876 60.8309 144.65 28.7734 104.897 28.7734C65.1442 28.7734 32.918 60.8309 32.918 100.376C32.918 139.921 65.1442 171.978 104.897 171.978Z",
    fill: "#E4E4E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15953_148823)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15953_148823)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105.275,
    cy: 100.373,
    r: 38.4392,
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.274 81.1523C94.6823 81.1523 86.0547 89.7797 86.0547 100.372C86.0547 110.964 94.6823 119.592 105.274 119.592C115.866 119.592 124.494 110.964 124.494 100.372C124.494 89.7797 115.866 81.1523 105.274 81.1523ZM113.816 104.429H105.274C104.078 104.429 103.139 103.49 103.139 102.294V91.8299C103.139 90.6339 104.078 89.6944 105.274 89.6944C106.47 89.6944 107.41 90.6339 107.41 91.8299V100.158H113.816C115.012 100.158 115.952 101.098 115.952 102.294C115.952 103.49 115.012 104.429 113.816 104.429Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter0_f_15953_148823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.54 71.7354C174.941 71.7354 187.427 59.2499 187.427 43.8482C187.427 28.4465 174.941 15.9609 159.54 15.9609C144.138 15.9609 131.652 28.4465 131.652 43.8482C131.652 59.2499 144.138 71.7354 159.54 71.7354Z",
    fill: "url(#paint1_linear_15953_148823)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M66.834 31.0351C70.9966 31.0351 74.3711 27.6607 74.3711 23.498C74.3711 19.3354 70.9966 15.9609 66.834 15.9609C62.6713 15.9609 59.2969 19.3354 59.2969 23.498C59.2969 27.6607 62.6713 31.0351 66.834 31.0351Z",
    fill: "url(#paint2_linear_15953_148823)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M165.827 163.485C158.482 161.517 150.932 165.876 148.964 173.221C146.996 180.566 151.355 188.117 158.7 190.085C166.045 192.053 173.596 187.694 175.564 180.349C177.532 173.003 173.173 165.453 165.827 163.485Z",
    fill: "url(#paint3_linear_15953_148823)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M38.7459 172.255C50.2898 172.255 59.648 162.914 59.648 151.391C59.648 139.868 50.2898 130.527 38.7459 130.527C27.202 130.527 17.8438 139.868 17.8438 151.391C17.8438 162.914 27.202 172.255 38.7459 172.255Z",
    fill: "url(#paint4_linear_15953_148823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15953_148823",
    x: 124.115,
    y: 8.42384,
    width: 70.8496,
    height: 70.8476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.76855,
    result: "effect1_foregroundBlur_15953_148823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15953_148823",
    x1: 104.897,
    y1: 28.7734,
    x2: 104.897,
    y2: 171.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6EAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15953_148823",
    x1: 130.659,
    y1: 85.394,
    x2: 169.799,
    y2: 10.7356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15953_148823",
    x1: 59.0283,
    y1: 34.7266,
    x2: 69.6068,
    y2: 14.5487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15953_148823",
    x1: 181.347,
    y1: 160.662,
    x2: 153.139,
    y2: 191.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15953_148823",
    x1: 17.0989,
    y1: 182.474,
    x2: 46.3518,
    y2: 126.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15953_148823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8783,
    height: 76.8783,
    fill: "white",
    transform: "translate(66.8359 61.9336)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15953_148823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8783,
    height: 76.8783,
    fill: "white",
    transform: "translate(66.8359 61.9336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/timezone.1db6fef676f4ebd0158c6376aac77639.svg";
export { ForwardRef as ReactComponent };